/* jshint es3:true */
/*
 * ISIS Dialog.
 *
 * Depends on:
 *   - main.js
 *   - mustache
 *   - jQuery
 *   - I18n messages:
 *     - button.ok
 *     - button.cancel
 *     - button.delete
 *     - dialog.confirm.title
 *     - dialog.confirm.yes
 *     - dialog.confirm.no
 *     - main.help.loading
 */
(function($i, $, undefined) {
    /**
     * Adaptation of jQuery's load function to force all requests to use the GET method (even in the data/params argument is provided).
     */
    $.fn.isisLoad = function(url, params, callback) {
        var selector, response, type,
            self = this,
            urlSeparator = url.indexOf(" ");

        if (urlSeparator >= 0) {
            selector = url.slice(urlSeparator, url.length);
            url = url.slice(0, urlSeparator);
        }

        // If params is a function then it is actually the callback.
        if ($.isFunction(params)) {
            callback = params;
            params = undefined;
        }

        // If we have elements to modify, make the request
        if (self.length > 0) {
            $.ajax({
                url: url,
                type: 'GET',
                dataType: "html",
                data: params
            }).done(function(responseText) {
                // Save response for use in complete callback
                response = arguments;

                self.html(selector ?
                    // If a selector was specified, locate the right elements in a dummy div
                    // Exclude scripts to avoid IE 'Permission Denied' errors
                    $("<div>").append($.parseHTML(responseText)).find(selector) :

                    // Otherwise use the full result.
                    responseText);
            }).always(callback && function(jqXHR, status) {
                self.each(callback, response || [ jqXHR.responseText, status, jqXHR ]);
            });
        }

        return this;
    };


    var defaults = {
        configuration: 'default',
        autoOpen: true,
        modal: true,

        // Whether to provide a close icon and/or close the dialog box when the escape key is pressed.
        closable: true,

        // Width/height in as in the argument of jQuery's .width(value) (see http://api.jquery.com/width/#width1).
        width: null,
        height: null,
        minWidth: null,
        maxWidth: null,

        // Whether to ignore the specified width on mobile.
        fullWidthMobile: true,
        // The maximum screen width that defines a mobile.
        mobileMaxScreenWidth: $i.maxWidthMobile,

        // The url (using the special syntax from jQuery's load methods (see http://api.jquery.com/load/)) for loading the dialog body via AJAX.
        url: null,
        data: {},

        // Selector for the dialog.
        dialogSelector: null,
        // Selector for the dialog body.
        bodySelector: null,

        // Dialog content for creating a dynamic dialog.
        title: null,
        body: null,
        buttons: {},

        // Dialog content for creating a dynamic dialog with translated text.
        titleKey: null,
        bodyKey: null,
        buttonKeys: {
            'button.ok': { classes: 'btn-primary', callback: function() {
                this.close();
            }}
        },

        // Events
        load: null,
        open: null,
        close: null,
        destroy: null,
        confirm: null,
        cancel: null,
        afterClose: null
    },
    configurations = {
        'default': {},
        'alert': {},
        'confirm': {
            titleKey: 'dialog.confirm.title',
            buttonKeys: {
                'dialog.confirm.yes': { classes: 'btn-primary', callback: function() {
                    var event = $.Event('confirm');
                    if ($i.isFunction(this.options.confirm)) { this.options.confirm.call(this, event); }
                    if (!event.isDefaultPrevented()) { this.destroy(); }
                }},
                'dialog.confirm.no': function(){
                    var event = $.Event('cancel');
                    if ($i.isFunction(this.options.cancel)) { this.options.cancel.call(this, event); }
                    if (!event.isDefaultPrevented()) { this.destroy(); }
                }
            }
        },
        'confirm-delete': {
            titleKey: 'dialog.confirm.title',
            buttonKeys: {
                'button.delete': { classes: 'btn-danger', callback: function() {
                    var event = $.Event('confirm');
                    if ($i.isFunction(this.options.confirm)) { this.options.confirm.call(this, event); }
                    if (!event.isDefaultPrevented()) { this.destroy(); }
                }},
                'button.cancel': function(){
                    var event = $.Event('cancel');
                    if ($i.isFunction(this.options.cancel)) { this.options.cancel.call(this, event); }
                    if (!event.isDefaultPrevented()) { this.destroy(); }
                }
            }
        }
    },
    overlayTemplate = '<div class="dialog-overlay"></div>',
    skeletonTemplate =  '<div class="dialog-box">' +
                            '<div class="dialog-content">' +
                                '<div class="dialog-head">' +
                                    '<h2>{{title}}</h2>' +
                                '</div>' +
                                '<div class="dialog-body"></div>' +
                                '<div class="dialog-foot"></div>' +
                            '</div>' +
                        '</div>',
    buttonTemplate   =  '<button type="button" class="dialog-injected-btn btn {{classes}}">{{label}}</button>',
    buttonLinkTemplate   =  '<a href="{{href}}" class="dialog-injected-btn btn {{classes}}">{{label}}</a>',
    closeButtonTemplate = '<i class="icon icon-times dialog-close-button" role="button" title="' + $i.i18n.get('button.close') +'" />',
    closed = false;

    // Constructor.
    function Dialog(options)
    {
        // Alias the 'closable' option for 'closable'.
        if (options.closeable !== undefined)  options.closable = options.closeable;

        this.options = $.extend({},
                                defaults,
                                configurations[options.configuration],
                                options);
        this.confirmLink = this.options.confirmLink;
        this.windowWidth = 0;
        this.windowHeight = 0;
        this.init();
    }

    Dialog.prototype.createButton = function (label, value) {
        var templateParams = {label: label}, callback = value, dialog = this;
        if ($i.isObject(value)) {
            callback = value.callback;
            $.extend(templateParams, value);
        }
        return $i.isString(templateParams.href) ?
            $($.mustache(buttonLinkTemplate, templateParams)) :
            $($.mustache(buttonTemplate, templateParams)).on('click', function () {
                callback.call(dialog);
            });
    };

    /**
     * Constructor.
     */
    Dialog.prototype.init = function () {
        var dialog = this,
            body = '',
            foot = $(),
            title;

        // Body
        if (dialog.options.url) {
            // Using body loaded via AJAX.
            body = $('<div class="dialog-ajax-placeholder">' + $i.i18n.get('main.help.loading') + '</div>');
        }
        else if (dialog.options.bodySelector) {
            // Using element from the document as the body.
            body = $(dialog.options.bodySelector).first().clone();
        }
        else if (dialog.options.bodyKey) {
            // Using translation as the body.
            body = $i.i18n.get(dialog.options.bodyKey);
        }
        else if (dialog.options.body) {
            // Using string as the body.
            body = dialog.options.body;
        }

        title = (dialog.options.titleKey) ? $i.i18n.get(dialog.options.titleKey) : dialog.options.title;

        // Overlay
        if (dialog.options.modal) {
            dialog.overlay = $(overlayTemplate).appendTo('body');
        }

        // Create the dialog.
        if (dialog.options.dialogSelector) {
            dialog.box = $(dialog.options.dialogSelector).first().appendTo('body');
        }
        else {
            dialog.box = $($.mustache(skeletonTemplate, {title: title})).hide().appendTo('body');
            dialog.box.find('.dialog-body').append(body);
        }

        // Close button in head.
        if (dialog.options.closable) {
            dialog.box.find('.dialog-head').find('.dialog-close-button').remove().end().append($.mustache(closeButtonTemplate));
        }

        // Foot (Buttons)
        foot = dialog.box.find('.dialog-foot');

        foot.find('.dialog-injected-btn').remove();
        if (!$i.isEmpty(dialog.options.buttons)) {
            $.each(dialog.options.buttons, function(key, value){
                dialog.createButton(key, value).appendTo(foot);
            });
        }
        else if (!$i.isEmpty(dialog.options.buttonKeys)) {
            $.each(dialog.options.buttonKeys, function(key, value){
                dialog.createButton($i.i18n.get(key), value).appendTo(foot);
            });
        }

        // AJAX body.
        if (dialog.options.url) {
            body.isisLoad(dialog.options.url, dialog.options.data, function() {
                dialog.open();
                if ($i.isFunction(dialog.options.load)) {
                    dialog.options.load.apply(dialog, Array.prototype.slice.call(arguments));
                }
            });
        }
        else if (dialog.options.autoOpen) {
            dialog.open();
        }

        dialog.box.data('isis-dialog', dialog);

        // Alias dialog.box.
        dialog.$el = dialog.box;
    };

    /**
     * Open the dialog.
     */
    Dialog.prototype.open = function () {
        // Disable scrolling on Safari while dialog is open.
        if(navigator.userAgent.indexOf("Safari") > -1){
           $("head").append('<meta name="viewport" content="width=device-width,initial-scale=1.0,maximum-scale=1.0,user-scalable=no"/>');
        }
        var dialog = this;

        // Make sure this dialog appears above all other dialogs.
        var zIndex = $('.dialog-box').get().reduce(function(acc, cur) {
            var z = Number($(cur).css('z-index')) || 0;
            return z > acc ? z : acc;
        }, 0) + 100;

        dialog.box.css('z-index', zIndex);
        if (dialog.options.modal) {
            dialog.overlay.css('z-index', zIndex);
            dialog.overlay.show();
            $('body').addClass('disable-scroll');
        }
        dialog.box.show().trigger('dialog-open');
        if(document.activeElement)
        {
            document.activeElement.blur();
        }
        $(window).on('resize.isis-dialog', _.debounce($.proxy(dialog.resize, dialog), 300));
        if (dialog.options.closable) {
            $(document).on('keyup.isis-dialog', $.proxy(dialog.closeOnEscapeKey, dialog));
            dialog.box.find('.dialog-head .dialog-close-button').on('click.isis-dialog', $.proxy(dialog.closeDialog, dialog, true));
        }
        dialog.resize();
        if ($i.isFunction(dialog.options.open)) {
            // Defer so that the dialog object is returned before fireing the open callback.
            _.defer(function () { dialog.options.open.call(dialog); });
        }
        dialog.closed = false;
        return dialog;
    };

    Dialog.prototype.closeDialog = function (closedByUser) {
        if(navigator.userAgent.indexOf("Safari") > -1){
           $("meta[name=viewport]").remove();
        }
        var dialog = this;
        if (dialog.options.modal) {
            dialog.overlay.hide();
            $('body').removeClass('disable-scroll');
            dialog.overlay.css('z-index', '');
        }
        dialog.box.hide().trigger('dialog-close');
        dialog.box.css('z-index', '');
        $(window).off('resize.isis-dialog');
        if (dialog.options.closable) { $(document).off('keyup.isis-dialog'); }
        dialog.closed = true;
        if ($i.isFunction(dialog.options.close)) { dialog.options.close.call(dialog, closedByUser); }
        return dialog;
    };

    /**
     * Close the dialog.
     */
    Dialog.prototype.close = function () {
        return this.closeDialog(false);
    };

    /**
     * Destroy the dialog.
     */
    Dialog.prototype.destroy = function () {
        var dialog = this;

        if (!dialog.closed) {
            // Call close as this will unbind events and call the close callback.
            dialog.close();
        }

        if (dialog.options.modal) { dialog.overlay.remove(); }
        dialog.box.remove();
        if ($i.isFunction(dialog.options.destroy)) { dialog.options.destroy.call(dialog); }
    };

    /**
     * Sets the height and width of the overlay to cover the whole document and repositions the dialog.
     */
    Dialog.prototype.resize = function (event) {
        var dialog = this,
            windowHeight = $(window).height(),
            windowWidth = $(window).width(),
            body = dialog.box.find('.dialog-body'),
            documentHeight,
            dialogTop,
            dialogLeft,
            marginTop,
            maxHeight,
            bodyPadding,
            maxBodyHeight;

        if (!$i.isObject(event) || dialog.windowHeight !== windowHeight || dialog.windowWidth !== windowWidth) {
            /*
             * If this method is called as the result of an event ('event' will be an object): only recalculate position/width/height if
             * the window size has changed. If the 'event' argument is not an object then this method has probably been called manually,
             * in which case we best do what the caller has asked.
             */
            dialog.windowWidth = windowWidth;
            dialog.windowHeight = windowHeight;
            if (!dialog.options.fullWidthMobile || windowWidth > dialog.options.mobileMaxScreenWidth) {
                // Not mobile.

                // Set width.
                if (dialog.options.width) {
                    dialog.box.width(dialog.options.width);
                }

                // Set height.
                if (dialog.options.height) {
                    dialog.box.height(dialog.options.height);
                }

                // Set minimum width.
                if (typeof dialog.options.minWidth === 'number' && dialog.box.width() < dialog.options.minWidth) {
                    dialog.box.width(dialog.options.minWidth);
                }

                // Set maximum width.
                if (typeof dialog.options.maxWidth === 'number' && dialog.box.width() > dialog.options.maxWidth) {
                    dialog.box.width(dialog.options.maxWidth);
                }
            }
            else {
                // Mobile
                dialog.box.width(windowWidth - 10);
            }

            // Calculate the values for centre alignment.
            // Use the CSS height value as this accounts for the box-sizing property.
            documentHeight = $(document).height();

            // Calculate the maximum height that the dialog body can be without having to introduce a vertical scroll bar.
            marginTop = Math.max(Math.min((documentHeight/3) - dialog.box.height(), 30), 50);
            bodyPadding = body.outerHeight() - body.height();
            maxBodyHeight = windowHeight - (marginTop * 2) - dialog.box.find('.dialog-foot').outerHeight() - dialog.box.find('.dialog-head').outerHeight() - bodyPadding;

            dialogTop = marginTop;
            dialogLeft = (windowWidth/2) - (dialog.box.width()/2);

            // Explicitly reset the overflow and height otherwise when switching from
            // normal to mobile layout, the height of the dialog box extends beyond the
            // window height with tall dialog box bodies
            body.css({ overflowY: 'auto', overflowX: 'auto', height: 'auto' });

            // Assign maxHeight to force a scrollbar whenever body content is larger than allowed
            body.css({ maxHeight: maxBodyHeight });

            // Move into place.
            dialog.box.css({ top: dialogTop, left: dialogLeft });

            /*
             * Resize the overlay. We have to use _.defer to allow the changes above to take effect before we
             * evaluate the document height (moving the dialog may have changed the documents height).
             */
            if (dialog.options.modal) {
                _.defer(function(){
                    documentHeight = $(document).height();
                    dialog.overlay.css({ height: documentHeight < windowHeight ? windowHeight : documentHeight });
                });
            }
        }
    };

    /**
     * Closes the dialog after pressing the escape key.
     */
    Dialog.prototype.closeOnEscapeKey = function (ev) {
        // if escape button is pressed
        if (ev.keyCode == 27) {
            var dialog = this;
            // call close as this will unbind events
            dialog.closeDialog(true);
        }
    };

    // Bind the dialog to the application namespace.
    $i.dialog = function () {
        // Plain options object.
        var options = arguments[0];

        // Single string argument: dialog selector.
        if (arguments.length === 1 && $i.isString(arguments[0])) {
            options = { dialogSelector: arguments[0] };
        }

        // String and an object: configuration name and options object.
        else if (arguments.length === 2 && $i.isString(arguments[0]) && $i.isObject(arguments[1])) {
            options = $.extend(arguments[1], { configuration: arguments[0] });
        }

        return new Dialog(options);
    };

    // Allow access to the dialog object from the dialog element.
    $.fn.getDialog = function () {
        return this.data('isis-dialog');
    };

})(isis, jQuery);
